export default __webpack_public_path__ + "static/media/thumbinvest.bb07b483.png";